module.exports = __webpack_public_path__ + "img/iran.806c015.webp";